import { render, staticRenderFns } from "./UserChangePassword.vue?vue&type=template&id=49aadd34&scoped=true"
import script from "./UserChangePassword.js?vue&type=script&lang=js&external"
export * from "./UserChangePassword.js?vue&type=script&lang=js&external"
import style0 from "./UserChangePassword.scss?vue&type=style&index=0&id=49aadd34&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aadd34",
  null
  
)

export default component.exports